// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-5649d56fa59908ea.js";
	if (chunkId === 9375) return "static/chunks/9375-12fa6b5f2abdf35f.js";
	if (chunkId === 9623) return "static/chunks/9623-6b80ce284a63cf78.js";
	if (chunkId === 7600) return "static/chunks/7600-ac71172b3dc40098.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","308":"c66364f79f3f0cac","2592":"d733a065c737d780","3156":"73e657ddec4a6d95","4686":"115275b932ae91d1","5891":"cf47f6092df0f4e1","6534":"f4a9a1c1bfa02b15","9074":"614b373a7dbeec1d","9724":"96943211c83b5fbc"}[chunkId] + ".js";
};